@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="LocationCsvKeys.ssoLocationId">
			{{ LOCATION_CSV_LABELS[LocationCsvKeys.ssoLocationId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LocationCsvKeys.name">
			{{ LOCATION_CSV_LABELS[LocationCsvKeys.name] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LocationCsvKeys.displayOrder">
			{{ LOCATION_CSV_LABELS[LocationCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="LocationCsvKeys.active">
			{{ LOCATION_CSV_LABELS[LocationCsvKeys.active] }}
		</ng-template>
		<ng-template appHeaderColumn="users"><span nz-tooltip="Assignment Status">Users</span></ng-template>
		<ng-template appHeaderColumn="assigned"><span nz-tooltip="Assigned">Assigned</span></ng-template>
		<ng-template appHeaderColumn="historical">
			<span
				[nz-tooltip]="
					'Is the selected user currently assigned in this section or' +
					' has the selected user been assigned in this section at any time in the past?'
				"
			>
				Historical
			</span>
		</ng-template>
		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="LocationCsvKeys.ssoLocationId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="LocationCsvKeys.ssoLocationId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LocationCsvKeys.name" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="LocationCsvKeys.name"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LocationCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="LocationCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="LocationCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="LocationCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template appRowColumn="users" [rowType]="rowType" let-row>
			<app-setup-wizard-location-users-status
				[location]="row"
				[enableEditButton]="enableEditButton()"
				(onEdit)="onEditUsersClick($event)"
			></app-setup-wizard-location-users-status>
		</ng-template>

		<ng-template appRowColumn="assigned" [rowType]="rowType" let-row>
			{{ isSelectedUserAssigned(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="historical" [rowType]="rowType" let-row>
			{{ isSelectedUserHistorical(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status-with-assignment
				[data]="row"
				[location]="row"
			></app-setup-wizard-before-after-status-with-assignment>
		</ng-template>

		<ng-template #actions let-row>
			@if (enableAssignButton() || enableUnassignButton()) {
				@let user = selectedUser();
				@let isUserAssigned = user ? isSelectedUserAssigned(row) : false;

				restrict to schol admin

				@if (enableAssignButton()) {
					@if (!isUserAssigned) {
						<button
							nz-button
							nzType="primary"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to assign this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onAssignClick(row)"
						>
							Assign
						</button>
					}
				}
				@if (enableUnassignButton()) {
					@if (isUserAssigned) {
						<button
							nz-button
							nzType="default"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to unassign this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onUnassignClick(row)"
						>
							Unassign
						</button>
					}
				}
			}
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
